$(document).on("click", ".subscription-selection-btn-sidebar", function () {
  var type = $(this).data("type");
  var form = $(this).data("form");
  if (
    $("#" + form)
      .find(".subscription_selection #" + type)
      .hasClass("active")
  ) {
  } else {
    console.log(type);
    console.log(form);
    $("#" + form)
      .find(".subscription_selection")
      .removeClass("active");
    $("#" + form)
      .find(".product-subscription__options_container #" + type)
      .addClass("active");
    $("#" + form)
      .find(".subscription-selection-btn-sidebar")
      .removeClass("selected");

    $(this).addClass("selected");
    if (type == "subsave") {
      $("#" + form)
        .find('[name="selling_plan"]')
        .attr("disabled", false);
      $("#" + form)
        .find("span[data-product-price]")
        .text(
          $("#" + form)
            .find("span[data-subscription-discounted-price]")
            .text()
        );
      $(".original_price").show();
      //$('.original_price').text($('#'+form).find('span[data-original-price]').text());
    } else {
      $("#" + form)
        .find('[name="selling_plan"]')
        .attr("disabled", true);
      $("#" + form)
        .find("span[data-product-price]")
        .text(
          $("#" + form)
            .find("span[data-original-price]")
            .text()
        );
      $(".original_price").hide();
    }
  }
});

const bindContractButtons = () => {
  const msContractButtons = document.querySelectorAll(
    "[data-ms-contract-button]"
  );

  if (msContractButtons.length > 0) {
    msContractButtons.forEach((button) => {
      button.addEventListener("click", async (event) => {
        event.preventDefault();

        const url = button.getAttribute("href");
        window.history.pushState({}, "", url);

        const loading = document.querySelector("[data-product-info-loading]");
        loading.classList.add("show");

        const res = await fetch(url);
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, "text/html");
        document.querySelector(".product-monthly-subscription").innerHTML =
          doc.querySelector(".product-monthly-subscription").innerHTML;

        // Kartik - February 23, 2024 - I'm not really sure why this was needed with Recharge, but Ordergroove seems to work without it.

        // // insert dynamic selling_plan
        // const sellingPlan = document.createElement("input");
        // sellingPlan.type = "hidden";
        // sellingPlan.name = "selling_plan";
        // sellingPlan.value = '';
        // if (url.includes('barkbox-12-month')) {
        //   sellingPlan.value = '1864761431';
        // } else if (url.includes('barkbox-6-month')) {
        //   sellingPlan.value = '1266352215';
        // } else if (url.includes('barkbox-monthly')) {
        //   sellingPlan.value = '1266319447';
        // } else if (url.includes('superchewer-12-month')) {
        //   sellingPlan.value = '1266483287';
        // } else if (url.includes('superchewer-6-month')) {
        //   sellingPlan.value = '1266450519'
        // } else if (url.includes('superchewer-monthly')) {
        //   sellingPlan.value = '1266417751'
        // }

        // const pdpForm = document.querySelector(".product-info__buy-buttons form");
        // pdpForm.prepend(sellingPlan);

        bindContractButtons();

        loading.classList.remove("show");
      });
    });
  }
};

bindContractButtons();

const scrollChatIntoView = () => {
  setTimeout(function () {
    const selfServiceHeader = document.getElementById("sidekick-title");
    if (selfServiceHeader) {
      selfServiceHeader.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }
  }, 500);
};

if (navigator.userAgent.match(/Android/i)) {
  document.addEventListener("DOMContentLoaded", function () {
    const chatButton = document.getElementById("gladly-chat-button");

    chatButton?.addEventListener("click", function () {
      if (chatButton.classList.contains("available")) {
        const checkGladlyTextBox = setInterval(function () {
          const gladlyTextBox = document.getElementById("gladlyTextBox");

          if (gladlyTextBox) {
            clearInterval(checkGladlyTextBox);
            gladlyTextBox.addEventListener("focus", scrollChatIntoView());
          }
        }, 500);
      }
    });

    const chatButtonContact = document.getElementById("gladly-chat-button-contact");
    chatButtonContact?.addEventListener("click", function () {
      if (chatButtonContact.classList.contains("available")) {
        const checkGladlyTextBox = setInterval(function () {
          const gladlyTextBox = document.getElementById("gladlyTextBox");

          if (gladlyTextBox) {
            clearInterval(checkGladlyTextBox);
            gladlyTextBox.addEventListener("focus", scrollChatIntoView());
          }
        }, 500);
      }
    });
  });
}

const scrollbarContainer = document.querySelector('.dsgn-pck__link-menu-icons .fc-scrollbar-container');
const scrollbarProgress = document.querySelector('.dsgn-pck__link-menu-icons .fc-scroll-progress');

function updateScrollbar() {
  const windowWidth = window.innerWidth;
  let featuredCollectionContainer = document.querySelector('.dsgn-pck__link-menu-icons .dsgn-pck__sizer');
  if (windowWidth <= 480) {
    featuredCollectionContainer = document.querySelector('.dsgn-pck__link-menu-icons .dsgn-pck__sizer ul');
  }
  const contentWidth = featuredCollectionContainer.scrollWidth;
  const containerWidth = scrollbarContainer.offsetWidth;
  const scrollWidth = containerWidth / contentWidth * 100;
  scrollbarProgress.style.width = `${scrollWidth}%`;
  featuredCollectionContainer.addEventListener("scroll", updateScrollbarProgress);
}

function updateScrollbarProgress() {
  const windowWidth = window.innerWidth;
  let featuredCollectionContainer = document.querySelector('.dsgn-pck__link-menu-icons .dsgn-pck__sizer');
  let blankSpace = 5;
  if (windowWidth <= 480) {
    featuredCollectionContainer = document.querySelector('.dsgn-pck__link-menu-icons .dsgn-pck__sizer ul');
    blankSpace = 1;
  }
  const contentWidth = featuredCollectionContainer.scrollWidth;
  const contentScroll = featuredCollectionContainer.scrollLeft;
  const containerWidth = scrollbarContainer.offsetWidth;
  const scrollWidth = (containerWidth + contentScroll) / contentWidth * 100;
  scrollbarProgress.style.width = `${scrollWidth + blankSpace}%`;
}

if (scrollbarContainer && scrollbarProgress) {
  document.addEventListener("DOMContentLoaded", updateScrollbar);
  window.addEventListener('resize', updateScrollbar);
}
